import React from 'react';
import { InfoIcon } from '../Icons';

const SankeyDiagramInfo = () => {
  const [open, setOpen] = React.useState(false);
  const iconRef = React.useRef();
  const [popoverPos, setPopoverPos] = React.useState({ top: 0, left: 0 });
  const popoverTimeout = React.useRef();

  const showPopover = () => {
    clearTimeout(popoverTimeout.current);
    if (iconRef.current) {
      const rect = iconRef.current.getBoundingClientRect();
      const popoverWidth = 320;
      const minMargin = 8;
      let left = rect.left + rect.width / 2 - popoverWidth / 2;
      if (left < minMargin) left = minMargin;
      if (left + popoverWidth > window.innerWidth - minMargin) left = window.innerWidth - minMargin - popoverWidth;
      setPopoverPos({
        top: rect.bottom + 6,
        left: left
      });
    }
    setOpen(true);
  };
  const hidePopover = () => {
    popoverTimeout.current = setTimeout(() => setOpen(false), 120);
  };
  const cancelHidePopover = () => {
    clearTimeout(popoverTimeout.current);
  };
  return (
    <>
      <span
        ref={iconRef}
        style={{ display: 'inline-flex', alignItems: 'center', height: 16, width: 16, marginLeft: 4, cursor: 'pointer', marginBottom: 8 }}
        aria-label="Explain risk score bar chart"
        tabIndex={0}
        onMouseEnter={showPopover}
        onMouseLeave={hidePopover}
        onFocus={showPopover}
        onBlur={hidePopover}
      >
        <InfoIcon size={13} color={'var(--primary-color)'} style={{ display: 'inline', verticalAlign: 'middle' }} />
      </span>
      {open && (
        <div
          style={{
            position: 'fixed',
            top: popoverPos.top,
            left: popoverPos.left,
            zIndex: 9999,
            background: 'var(--background, #23293a)',
            color: 'var(--text, #fff)',
            border: '1px solid var(--border, #444)',
            borderRadius: 8,
            boxShadow: '0 2px 8px rgba(0,0,0,0.18)',
            padding: '0.7rem 1rem',
            minWidth: 220,
            maxWidth: 320,
            fontSize: 14,
            pointerEvents: 'auto',
          }}
          onMouseEnter={cancelHidePopover}
          onMouseLeave={hidePopover}
        >
          <div style={{ fontWeight: 700, marginBottom: 6 }}>Information Stealers Diagram</div>
          <div style={{ fontWeight: 400 }}>
            This diagram shows the flow of information stealers by domain, computer type, and risk score. The computer type and risk score are classifications done with the use of heuristics (can be reclassified).
          </div>
        </div>
      )}
    </>
  );
};

export default SankeyDiagramInfo; 